<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Smart Factory"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Smart Factory
                    </h2>
                    <p>
                        Application of ICT (Information Communication Technology) that combines digital automation solutions in the production process. <br class="d-none d-md-block">
                        Introduction of processes that collect process data in real time and analyze themselves through IoT
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Field Data Aggregation">
                    <v-img src="/images/sub/wwd/factory/factory-img1-en.png" max-width="946" class="mx-auto d-none d-md-block"></v-img>
                    <v-img src="/images/sub/wwd/factory/factory-img1-mo-en.png" max-width="484" class="mx-auto d-block d-md-none"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="Data Aggregation Department">
                    <v-img src="/images/sub/wwd/factory/factory-img2-en.png" max-width="896" class="mx-auto d-none d-md-block"></v-img>
                    <v-img src="/images/sub/wwd/factory/factory-img2-mo-en.png" max-width="624" class="mx-auto d-block d-md-none"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
    },
};
</script>

<style lang="scss" scoped>
</style>